import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RoleProtectedRoute = ({ allowedRoles, redirectPath = '/login' }) => {
     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
     const userRole =
          sessionStorage.getItem('userRole') ||
          localStorage.getItem('userRole') ||
          sessionStorage.getItem('role') ||
          sessionStorage.getItem('user_role');

     // Debug log
     // console.log('RoleProtectedRoute:', { token, userRole, allowedRoles });

     if (!token) return <Navigate to={redirectPath} replace />;
     if (allowedRoles && !allowedRoles.includes(userRole)) {
          console.warn('RoleProtectedRoute: Role not allowed', { userRole, allowedRoles });
          return <Navigate to="/dashboard" replace />;
     }
     return <Outlet />;
};

export default RoleProtectedRoute;